<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <h1 class="title">{{ translate("live_streams.title") }}</h1>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <div class="buttons">
                        <button class="button is-primary" @click="openAddLiveStreamModal">
                            <span class="icon">
                                <i class="fa fa-plus"></i>
                            </span>
                            <span>{{ translate("live_streams.add") }}</span>
                        </button>
                        <a class="button is-text" :href="helpCenter().howToStartLiveStreaming()" target="_blank">
                            <span class="icon">
                                <i class="fa fa-question-circle"></i>
                            </span>
                            <span>
                                {{ translate("live_streams.how_to_setup") }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" v-if="initDone">
                <div class="column is-6" v-for="liveStream in liveStreams" :key="liveStream.id">
                    <LiveStream :live-stream="liveStream" />
                </div>

                <div class="column is-4 is-offset-4">
                    <Notification class="is-info" v-if="liveStreams.length === 0">
                        <span class="icon">
                            <i class="fa fa-info-circle"></i>
                        </span>
                        <span>
                            {{ translate("live_streams.no_streams") }}
                        </span>
                    </Notification>
                </div>
            </div>
            <div class="columns is-mobile is-centered" v-else>
                <LoadingSpinner2 class="has-added-margin" />
            </div>
        </div>

        <AddLiveStreamModal ref="addLiveStreamModal" />
    </section>
</template>

<script>
    import apiMixin from "../Api/apiMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import Notification from "../Common/Notification.vue";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import toastMixin from "../Common/toastMixin";
    import translatorMixin from "../Common/translatorMixin";
    import AddLiveStreamModal from "./AddLiveStreamModal.vue";
    import { eventBus, ON_ADD_LIVE_STREAM } from "./eventBus";
    import { mapState } from "vuex";
    import LiveStream from "./LiveStream.vue";
    import urlsMixin from "../Urls/urlsMixin";

    export default {
        name: "live-streams-manage-app",
        components: { LiveStream, AddLiveStreamModal, Notification, LoadingSpinner2 },
        mixins: [apiMixin, errorHandlerMixin, toastMixin, translatorMixin, urlsMixin],
        props: ["eventId"],
        data() {
            return {
                initDone: false,
                selectedMatId: 0,
                visibleStreamKeys: {},
                deletingInProgress: "",
                addingInProgress: false,
            };
        },
        computed: {
            ...mapState("main", ["liveStreams", "mats"]),
        },
        created() {
            this.$store.commit("main/setEventId", this.eventId);

            eventBus.$on(ON_ADD_LIVE_STREAM, () => {
                this.$refs.addLiveStreamModal.open();
            });
        },
        mounted() {
            this.initDone = false;
            return Promise.all([this.fetchLiveStreams(), this.fetchMats()]).finally(() => {
                this.initDone = true;
            });
        },
        methods: {
            fetchMats() {
                return this.matsApi()
                    .getMatsListing(this.eventId)
                    .then(mats => {
                        this.$store.commit("main/setMats", mats);
                    });
            },
            fetchLiveStreams() {
                return this.liveStreamsApi()
                    .getListing(this.eventId)
                    .then(liveStreams => {
                        this.$store.commit("main/setLiveStreams", liveStreams);
                    });
            },

            openAddLiveStreamModal() {
                eventBus.$emit(ON_ADD_LIVE_STREAM);
            },
        },
    };
</script>

<style scoped></style>
